import { useState, useRef, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../redux/snackbarSlice";

const AppBarButton = ({ button, index, disableBarButtons }) => {
  const [hoveredButton, setHoveredButton] = useState(null);
  const buttonRef = useRef(null);
  /** Idle width (px) — applied while loading so the control does not grow or shrink */
  const idleWidthPxRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isInteractionBlocked = disableBarButtons || button.disabled;
  const isLoading = Boolean(button.loading);
  const isDisabled = isInteractionBlocked || isLoading;

  const handleButtonClick = (e) => {
    if (isLoading) {
      e.preventDefault();
      return;
    }
    if (isInteractionBlocked && button.title) {
      e.preventDefault();
      dispatch(
        showSnackbar({
          message: button.title,
          type: "warning",
        })
      );
      return;
    }

    if (button.onClick) {
      button.onClick();
    } else if (button.path) {
      navigate(button.path);
    }
  };

  const getButtonClassName = () => {
    const baseClass =
      button.label !== "Reject" &&
      button.label !== "Preview" &&
      button.label !== "Review" &&
      button.label !== "Copy" &&
      button.label !== "Copy & Replace" &&
      button.label !== "Request Change" &&
      button.label !== "Get Training" &&
      button.label !== "Give Training" &&
      (typeof button.label === "string"
        ? !button.label.toLowerCase().includes("move") &&
          !button.label.toLowerCase().includes("paste") &&
          !button.label.toLowerCase().includes("module") &&
          !button.label.toLowerCase().includes("Paste up") &&
          !button.label.toLowerCase().includes("Paste below") &&
          !button.label.toLowerCase().includes("Paste into")
        : true)
        ? typeof button.label === "string"
          ? "appbar-button"
          : "appbar-icon-button"
        : "appbar-button-secondary";

    return `${baseClass} ${isDisabled ? "appbar-button-disabled" : ""} ${
      isLoading ? "appbar-button--loading" : ""
    }`.trim();
  };

  const loadingAriaLabel =
    isLoading && typeof button.label === "string"
      ? button.label
      : isLoading
        ? "Loading"
        : undefined;

  useLayoutEffect(() => {
    if (!isLoading && buttonRef.current) {
      idleWidthPxRef.current = buttonRef.current.offsetWidth;
    }
  }, [isLoading, button.label]);

  const widthLockStyle =
    isLoading && idleWidthPxRef.current != null
      ? {
          width: idleWidthPxRef.current,
          minWidth: idleWidthPxRef.current,
          maxWidth: idleWidthPxRef.current,
          boxSizing: "border-box",
        }
      : {};

  return (
    <button
      ref={buttonRef}
      key={index}
      type="button"
      className={getButtonClassName()}
      disabled={isLoading}
      onClick={handleButtonClick}
      // onMouseEnter={() => setHoveredButton(isDisabled ? button.title : null)}
      onMouseLeave={() => setHoveredButton(null)}
      style={{
        position: "relative",
        ...(button.style || {}),
        ...widthLockStyle,
      }}
      aria-busy={button.loading ? true : undefined}
      aria-label={loadingAriaLabel}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: isLoading ? 0 : "8px",
          minHeight: "1.25em",
          width: isLoading ? "100%" : undefined,
        }}
      >
        {button.loading ? (
          <span className="appbar-btn-spinner" aria-hidden />
        ) : (
          button.label
        )}
      </span>
      {isDisabled && hoveredButton === button.title && (
        <div
          style={{
            position: "absolute",
            bottom: "-40px",
            left: "50%",
            backgroundColor: "#333",
            color: "#fff",
            padding: "8px",
            borderRadius: "4px",
            zIndex: 10,
            fontSize: "12px",
            whiteSpace: "nowrap",
            maxWidth: "400px",
            wordWrap: "break-word",
            left: "auto",
            right: "0",
          }}
        >
          {button.title}
        </div>
      )}
    </button>
  );
};

export default AppBarButton;
